import React from "react";
import Main from "../pages/Main";
import AppBreadcrumbs from "../components/ui/AppBreadcrumbs";
import ElectricBoltIcon from "@mui/icons-material/ElectricBolt";
import CircleIcon from "@mui/icons-material/Circle";
import { useNavigate } from "react-router-dom";

const AddMoney = () => {
  const navigate = useNavigate();
  const gatewayList = [
    {
      id: 1,
      title: "PG — TERMINAL LOAD (ALL CARDS)",
      img: "/razorpay_pg.png",
      rule: "200-90000",
      label: " Add Money",
      path: "/initiate/200-90000",
    },
    {
      id: 2,
      title: "PG + PAYOUT — CARD COLLECT & BANK PAYOUT",
      img: "/razorpay_pg.png",
      rule: "1-90000",
      label: "PG + Payout",
      path: "/pg-payout",
    },
  ];

  return (
    <Main showRightPanel={false}>
      <div className="mt-4 font-[Poppins]">
        <AppBreadcrumbs
          items={[
            { label: "Dashboard", to: "/" },
            { label: "MATM Module" },
            { label: " Add Money" },
          ]}
        />

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-6">
          {gatewayList.map((g) => (
            <div
              key={g.id}
              onClick={() => navigate(g.path || `/initiate/${g.rule}`)}
              className="cursor-pointer ds-card hover:border-[var(--primary-color)] transition"
            >
              <div className="flex items-center gap-2 mb-2 make-text-primary font-semibold">
                <ElectricBoltIcon fontSize="small" />
                {g.label}
              </div>
              <p className="text-sm text-[var(--text-muted)] mb-3">{g.title}</p>
              <div className="flex items-center gap-2 text-xs text-[var(--success-color)]">
                <CircleIcon sx={{ fontSize: 10 }} />
                Limit ₹{g.rule.replace("-", " – ₹")}
              </div>
            </div>
          ))}
        </div>
      </div>
    </Main>
  );
};

export default AddMoney;
